import { createContext } from 'react';
import { IInternationalizationContext } from './IInternationalizationContext';

const InternationalizationContext = createContext<IInternationalizationContext>({
  currency: 'USD',
  locale: 'us',
});

export default InternationalizationContext;
